import { render, staticRenderFns } from "./perfil.vue?vue&type=template&id=7568b028&"
import script from "./perfil.vue?vue&type=script&lang=ts&"
export * from "./perfil.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports